document.addEventListener('click', (e) => {
  const btn = e.target.closest('.header-locale-switcher__toggle');
  const wrap = e.target.closest('.header-locale-switcher');
  if (btn && wrap) {
    const dd = wrap.querySelector('.header-locale-switcher__dropdown');
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!expanded));
    dd.hidden = expanded;
  }
  if (!wrap) {
    document.querySelectorAll('.header-locale-switcher__dropdown:not([hidden])').forEach(dd => {
      dd.hidden = true;
      const t = dd.closest('.header-locale-switcher').querySelector('.header-locale-switcher__toggle');
      if (t) t.setAttribute('aria-expanded', 'false');
    });
  }
});

document.addEventListener('change', (e) => {
  if (e.target.matches('.header-locale-switcher__select')) {
    const form = e.target.closest('form');
    if (form) form.submit();
  }
});
